import { toast } from '@/components/toast';
import { cloneVoice } from '@/services/api';
import { ALL_VOICES_ID } from '@/state/presenters';
import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

export function useUpsertVoice(onDone?: () => void, disableToasts?: boolean, refetchVoices?: () => Promise<void> | void) {
    const queryClient = useQueryClient();

    return useMutation(cloneVoice, {
        onSuccess: async () => {
            await queryClient.invalidateQueries([ALL_VOICES_ID]);
            await refetchVoices?.();
            if (!disableToasts) {
                toast.success({ title: 'Voice added successfully', toastId: `upsert-clone-voice-success` });
            }
            onDone?.();
        },
        onError: (error: AxiosError<{ kind: string; description?: string }>) => {
            if (!disableToasts) {
                if (error.response?.data.kind === 'PlanLimitExceededError') {
                    toast.error({ title: 'Cloned voices limit reached' });
                } else {
                    toast.error({ title: 'Error during adding voice', toastId: `upsert-clone-voice-error` });
                }
            }
            onDone?.();
        },
    });
}
